import $ from "jquery";

// Das Zeug hat nur teilweise direkt was mit der Artikelauswahl zu tun und muss entwurschtelt werden
const $artikelauswahl = $('#product-dimensions');
const $artikelNr = $("#artikelnr");

export const artikelauswahlSettings = {
	normblattGuid: $artikelauswahl.data("artikelauswahl-normblattguid"),
	deliveryCountry: $artikelauswahl.data("delivery-country"),
	masseinheit: $artikelauswahl.data("artikelauswahl-masseinheit"),
	cadDatenVorhanden: $artikelauswahl.data("cad-daten-vorhanden") == "True",
};

export function getArtikelNrOhneEigentuemer() {
	return $artikelNr.attr("data-artikelnr-ohne-eigentuemer")!;
}
